import { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import { Component as GoogleIcon } from 'payment-img/google-pay/google-pay-icon.svg';
import { Component as AppleIcon } from 'icons/icon-social--apple.svg';
import { Component as FacebookIcon } from 'icons/icon-social--facebookbtn.svg';
import { ApiRoute } from '../../utils/config';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import styles from './CreateAccount.module.scss';

type Props = {
  isLogin: boolean;
}

export function SocialSignup({ isLogin }: Props): ReactElement {
  const { cart } = useMenuWithCart();
  const { pathname, search } = useLocation();
  const origin = encodeURIComponent(`${pathname}${search}`);
  const isSignupEnabled = isLogin || !cart?.priceSummary.remainingMinimumAmount;

  const handleClick = () => {
    if (isLogin === true) {
      return;
    }
    localStorage.setItem('socialSignup', 'true');
  };

  return (
    <div className={styles.sso_button_container}>
      <a
        className={`${styles.sso_button} ${styles.google_button} ${isSignupEnabled ? '' : styles.disabled}`}
        data-heap-id={`${isLogin ? 'login_google' : 'signup_google'}`}
        href={`${ApiRoute.GOOGLE_SSO}?origin=${origin}`}
        onClick={handleClick}
      >
        <GoogleIcon />
        {`${isLogin ? 'Log in' : 'Sign up'} with Google`}
      </a>
      <a
        className={`${styles.sso_button} ${styles.apple_button} ${isSignupEnabled ? '' : styles.disabled}`}
        data-heap-id={`${isLogin ? 'login_apple' : 'signup_apple'}`}
        href={`${ApiRoute.APPLE_SSO}?origin=${origin}`}
        onClick={handleClick}
      >
        <AppleIcon />
        {`${isLogin ? 'Log in' : 'Sign up'} with Apple`}
      </a>
      <a
        className={`${styles.sso_button} ${styles.facebook_button} ${isSignupEnabled ? '' : styles.disabled}`}
        data-heap-id={`${isLogin ? 'login_facebook' : 'signup_facebook'}`}
        href={`${ApiRoute.FACEBOOK_SSO}?origin=${origin}`}
        onClick={handleClick}
      >
        <FacebookIcon />
        {`${isLogin ? 'Log in' : 'Sign up'} with Facebook`}
      </a>
    </div>
  );
}
